import React, { useState } from "react";
import { Input, Button, Upload, Select, Tabs, Form } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { TabPane } = Tabs;

const PraiseComponent: React.FC = () => {
    const [form] = Form.useForm();

    const props = {
        beforeUpload: (file: File) => {
            // Prevent auto-upload
            return false;
        },
        maxCount: 5,
    };

    const onFinish = (values: any) => {
        console.log("Submitted Values: ", values);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: 20 }}
        >
            <Form.Item
                label="Search Employee"
                name="employee"
                rules={[{ required: true, message: "Please select an employee!" }]}
            >
                <Select
                    placeholder="Search Employee"
                    showSearch
                    options={[
                        { value: "employee1", label: "Employee 1" },
                        { value: "employee2", label: "Employee 2" },
                    ]}
                />
            </Form.Item>

            <Form.Item
                label="Reason for Praise"
                name="reason"
                rules={[
                    {
                        required: true,
                        message: "Please describe why the employee deserves praise!",
                    },
                ]}
            >
                <TextArea
                    rows={4}
                    placeholder="What did the employee do to deserve the praise?"
                />
            </Form.Item>

            <Form.Item
                label="Select Badge"
                name="badge"
                rules={[{ required: true, message: "Please select a badge!" }]}
            >
                <div style={{ textAlign: "center" }}>
                    <Button type="default" style={{ width: "100%" }}>
                        Select Badge
                    </Button>
                </div>
            </Form.Item>

            <Form.Item label="Add Attachment">
                <Upload {...props}>
                    <Button icon={<UploadOutlined />}>Add Attachment</Button>
                </Upload>
                <div style={{ fontSize: "12px", color: "#999", marginTop: 4 }}>
                    Max number of files allowed is 5
                </div>
            </Form.Item>
        </Form>
    );
};

export default PraiseComponent;
